export default __webpack_public_path__ + "static/media/island_3_with_objects.67512099.png";